var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoFind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06072 8.85261H6.12072V13.6526C6.12072 14.7726 6.72739 14.9993 7.46739 14.1593L12.5141 8.42595C13.1341 7.72595 12.8741 7.14595 11.9341 7.14595H9.87405V2.34595C9.87405 1.22595 9.26739 0.999281 8.52739 1.83928L3.48072 7.57261C2.86739 8.27928 3.12739 8.85261 4.06072 8.85261Z",
    stroke: "#575757",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoFind);
export default __webpack_public_path__ + "static/media/auto_find.70574a8fcf219d9825af003ac28c01a5.svg";
export { ForwardRef as ReactComponent };